import React, { memo, useCallback, useState, useEffect } from 'react';
import { InputText } from '../form';
import ButtonCustom from 'components/buttonCustom';
import { Modal, ModalTitle, GroupSearch, List, ListItem, ListButton } from './Styled';

const ModalRegionalSelect = ({
    isOpen,
    onClose,
    onSelect,
    fetchRegionalCommunication,
    title = 'Selecione a Regional',
}) => {
    const [regionalOptions, setRegionalOptions] = useState([]);
    const [filteredOptions, setFilteredOptions] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);

    // Fetch regional options when modal opens
    useEffect(() => {
        if (isOpen && fetchRegionalCommunication) {
            const loadRegionals = async () => {
                setLoading(true);
                try {
                    const options = await fetchRegionalCommunication();
                    setRegionalOptions(options || []);
                    setFilteredOptions(options || []);
                } catch (error) {
                    console.error('Error fetching regional options:', error);
                    setRegionalOptions([]);
                    setFilteredOptions([]);
                } finally {
                    setLoading(false);
                }
            };
            loadRegionals();
        }
    }, [isOpen, fetchRegionalCommunication]);

    // Filter options based on search term
    useEffect(() => {
        if (!searchTerm) {
            setFilteredOptions(regionalOptions);
        } else {
            const filtered = regionalOptions.filter((option) =>
                option.label?.toLowerCase().includes(searchTerm.toLowerCase()),
            );
            setFilteredOptions(filtered);
        }
    }, [searchTerm, regionalOptions]);

    const handleSearch = useCallback((e) => {
        setSearchTerm(e.target.value);
    }, []);

    const handleSelectRegional = useCallback(
        (option) => {
            if (onSelect) {
                onSelect(option.key, option.label);
            }
            setSearchTerm('');
            onClose();
        },
        [onSelect, onClose],
    );

    if (!isOpen) return null;

    return (
        <Modal onClose={() => {}} open={isOpen} disableEscapeKeyDown>
            <ModalTitle>{title}</ModalTitle>
            <GroupSearch>
                <InputText
                    fullWidth
                    transparent="true"
                    id="search"
                    name="search"
                    label="Buscar regional..."
                    autoComplete="off"
                    value={searchTerm}
                    onChange={handleSearch}
                />
            </GroupSearch>
            <List>
                {loading ? (
                    <ListItem>Carregando regionais...</ListItem>
                ) : filteredOptions.length === 0 ? (
                    <ListItem>Nenhuma regional encontrada</ListItem>
                ) : (
                    filteredOptions.map((option, index) => (
                        <ListItem key={index}>
                            <ListButton onClick={() => handleSelectRegional(option)}>{option.label}</ListButton>
                        </ListItem>
                    ))
                )}
            </List>
        </Modal>
    );
};

export default memo(ModalRegionalSelect);
